import { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import { YoutubePlaylistActions } from '~/components/containers/YoutubePlaylistContainer/types/actions.types';
import { YoutubePlaylistContainerConstants } from './constants';
import YoutubePlaylistRecord from './data/YoutubePlaylistRecord';

function getInitialState() {
  return new YoutubePlaylistRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<YoutubePlaylistRecord, YoutubePlaylistActions> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case YoutubePlaylistContainerConstants.TOGGLE_YOUTUBE_PLAYLIST_MODAL_OPEN:
      return state.merge({ modalIsOpen: !state.getModalIsOpen() });

    case YoutubePlaylistContainerConstants.GET_YOUTUBE_PLAYLIST_REQUEST:
      return state.setVideos([]).merge({
        isLoadingPlaylist: true,
        error: undefined,
      });

    case YoutubePlaylistContainerConstants.GET_YOUTUBE_PLAYLIST_REQUEST_SUCCESS:
      return state.setVideos(action.response).merge({
        isLoadingPlaylist: false,
      });

    case YoutubePlaylistContainerConstants.GET_YOUTUBE_PLAYLIST_REQUEST_ERROR:
      return state.merge({
        isLoadingPlaylist: false,
        error: new ErrorRecord(action.error),
      });

    case YoutubePlaylistContainerConstants.GET_VIDEO_LENGTHS_REQUEST_SUCCESS:
      return state.updateVideoDurations(action.response);

    default:
      return state;
  }
};

export default reducer;
